import { cn } from '@/libs/utils/cn';
import type { RecordMode } from '../utils/dealCreationDraft';

const MODES: readonly [RecordMode, string][] = [
  ['attach', 'Search existing'],
  ['create', 'Create new'],
];

interface RecordModeToggleProps {
  mode: RecordMode;
  onChange: (mode: RecordMode) => void;
}

/**
 * Attach-or-create, presented as a choice the BD makes up front rather than as the consequence of
 * a search that found nothing: the portal's index lags its records, so an empty result is not
 * proof the record does not exist.
 */
export function RecordModeToggle({ mode, onChange }: RecordModeToggleProps) {
  return (
    <div className="flex rounded-lg bg-slate-50 p-0.5" role="group">
      {MODES.map(([value, label]) => (
        <button
          key={value}
          type="button"
          aria-pressed={mode === value}
          onClick={() => onChange(value)}
          className={cn(
            'h-[34px] flex-1 rounded-[7px] text-[13px] transition-colors',
            mode === value
              ? 'bg-white font-semibold text-primary-700 shadow-[inset_0_0_0_1px_var(--border)]'
              : 'text-primary-600',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
